frontApp.favourite = {
  name: 'favourite',
  description: 'favourite',
  isOpen: false,
  init() {
    this.loadUserData();
    this.event();
  },
  event() {
    const self = this;
    $(document).on('click', '.js-favourite-btn', function () {
      const $curBtn = $(this);
      const $btnsInGroup = $curBtn.closest('.js-favourite-wrap').find('.js-favourite-btn');
      const id = $curBtn.data('id');
      if ($curBtn.hasClass('is-active')) {
        $.post(
          '/local/ajax/favorite.php',
          {
            action: 'remove',
            id,
          },
          () => {
            $curBtn.add($btnsInGroup).removeClass('is-active').attr('title', 'Отложить');
            // Найти все кноки добавления в Отложенные и удалить на них активный класс
            $.each($(`.btn_favorite__${id}`), function () {
              $(this).removeClass('is-active').attr('title', 'Отложить');
            });
          },
          'html',
        );
      } else {
        $.post(
          '/local/ajax/favorite.php',
          {
            action: 'add',
            id,
          },
          () => {
            $curBtn.add($btnsInGroup).addClass('is-active').attr('title', 'Удалить из отложенного');
            // Найти все кноки добавления в Отложенные и добавить им активный класс
            $.each($(`.btn_favorite__${id}`), function () {
              $(this).addClass('is-active').attr('title', 'Удалить из отложенного');
            });
          },
          'html',
        );
      }
      $curBtn.blur();
    });

    $(document).on('click', '.btn_salenote', function () {
      frontApp.loading.fullPage.show();
      $.post(
        '/local/ajax/salenote.php',
        {
          action: 'add',
          id: $(this).data('id'),
        },
        (html) => {
          self.showModal(html);
          self.loadUserData();
          frontApp.loading.fullPage.hide();
        },
        'html',
      );
      return false;
    });
    $(document).on('click', '.btn_rm_salenote', function () {
      frontApp.loading.fullPage.show();
      $.post(
        '/local/ajax/salenote.php',
        {
          action: 'remove',
          id: $(this).data('id'),
        },
        (html) => {
          self.showModal(html);
          self.loadUserData();
          frontApp.loading.fullPage.hide();
        },
        'html',
      );
      return false;
    });
  },
  loadUserData() {
    $.post(
      '/local/ajax/user_data.php',
      {
      },
      (data) => {
        if (data.show_favorite === 'Y') {
          $('.js-favourite-btn').removeClass('hide');
          $.each(data.favorite, function () {
            $(`.btn_favorite__${this}`).addClass('is-active').attr('title', 'Удалить из отложенного');
          });
        }

        if (typeof data.salenote !== 'undefined') {
          $('.btn_rm_salenote').removeClass('is-active');
          $('.btn_salenote').removeClass('hide');
          $.each(data.salenote, function () {
            $(`.btn_rm_salenote__${this}`).addClass('is-active');
            $(`.btn_salenote__${this}`).addClass('hide');
          });
        }
      },
      'json',
    );
  },
  showModal(text) {
    const html = `<div id="login_overlay" class="b_popup__overlay">
      <div id="login_modal" class="b_shadow_box b_modal b_popup">
        <div class="b_modal_close"></div>
        ${text}
      </div>
    </div> `;
    $('body').append(html);
  },
};
